<template>
  <section class="grades-section">
    <div class="section-container">
      <div class="section-label">{{ config.label || 'المراحل الدراسية' }}</div>
      <h2 class="section-title">{{ config.title || 'نغطي جميع المراحل' }}</h2>
      <div class="grades-grid">
        <div v-for="(stage, i) in stages" :key="i" :class="['grade-card', i % 2 === 0 ? 'gc-1' : 'gc-2']">
          <div class="grade-icon">{{ stage.icon }}</div>
          <h3>{{ stage.name }}</h3>
          <div class="grade-levels">
            <span v-for="(level, j) in stage.levels" :key="j">{{ level }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({ config: { type: Object, default: () => ({}) } });

const DEFAULT_STAGES = [
  { icon: '🏫', name: 'المرحلة الإعدادية', levels: ['ثالثة إعدادي'] },
  { icon: '🎓', name: 'المرحلة الثانوية', levels: ['أولى ثانوي', 'ثانية ثانوي', 'ثالثة ثانوي'] },
];
const stages = computed(() => (props.config.stages?.length ? props.config.stages : DEFAULT_STAGES));
</script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
.section-container { max-width:1200px;margin:0 auto;padding:0 2rem; }
.section-label { display:inline-block;background:rgba(91,95,239,.08);color:#5B5FEF;border:1px solid rgba(91,95,239,.2);border-radius:99px;padding:.3rem 1rem;font-size:.8rem;font-weight:700;margin-bottom:1rem; }
.section-title { font-size:clamp(1.6rem,3vw,2.2rem);font-weight:800;color:#111827;margin-bottom:2.5rem;line-height:1.3; }

.grades-section { padding:5rem 0;background:#fff; }
.grades-grid { display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:2rem; }
.grade-card { border-radius:24px;padding:2.5rem 2rem;display:flex;flex-direction:column;gap:1.25rem;position:relative;overflow:hidden;transition:transform .3s,box-shadow .3s; }
.grade-card:hover { transform:translateY(-6px); }
.gc-1 { background:linear-gradient(135deg,#5B5FEF,#7C4DFF);color:#fff;box-shadow:0 20px 50px rgba(91,95,239,.25); }
.gc-2 { background:linear-gradient(135deg,#00C2FF,#00D4A6);color:#fff;box-shadow:0 20px 50px rgba(0,212,166,.2); }
.grade-icon { font-size:2.5rem; }
.grade-card h3 { font-size:1.3rem;font-weight:800; }
.grade-levels { display:flex;flex-wrap:wrap;gap:.5rem; }
.grade-levels span { background:rgba(255,255,255,.2);backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,.3);border-radius:99px;padding:.3rem .9rem;font-size:.82rem;font-weight:600; }

/* ── Mobile app home: compact horizontal stage rows (icon • name • levels) ── */
@media (max-width: 768px) {
  .grades-section { padding: .5rem 0 .25rem; background: transparent; }
  .section-container { padding: 0 1rem; }
  .section-label { display: none; }
  .section-title { font-size: .72rem; font-weight: 800; color: #9CA3AF; letter-spacing: .04em; margin-bottom: .55rem; }
  .grades-grid { grid-template-columns: 1fr; gap: .55rem; }
  .grade-card {
    flex-direction: row;
    align-items: center;
    gap: .75rem;
    padding: .7rem .85rem;
    border-radius: 16px;
  }
  .grade-card:hover { transform: none; }
  .grade-icon {
    font-size: 1.2rem;
    width: 40px; height: 40px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    background: rgba(255,255,255,.18);
    border: 1px solid rgba(255,255,255,.28);
    border-radius: 12px;
  }
  .grade-card h3 { font-size: .92rem; margin: 0; flex-shrink: 0; }
  .grade-levels { gap: .3rem; flex: 1; justify-content: flex-end; }
  .grade-levels span { font-size: .64rem; padding: .16rem .5rem; }
}
</style>
